import React, { useEffect, useRef, useState } from "react";
import configurationManagementService from "@services/configuationManagement.service";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';

export default function BrTelMCI_CmNotInPM() {
  const [resultR, setResult] = useState({});
  const [data, setData] = useState([{ name: "Loading ......" }]);
  const [blocked, setBlocked] = useState(false);

  useEffect(() => {
    let isMounted = true;
    setBlocked(true);
    configurationManagementService.brtel_mci_cell_in_pm_check({}).then((result) => {
      if (isMounted) {
        if (result.data.length > 0) {
          setResult(result.data);
          setData(result.data);
          // console.log(result.data[kpi[0].name]);
          setBlocked(false);
        } else {
          setData([{ name: "No Data ......" }]);
          setBlocked(false);
        }
      }
    });
    return () => { isMounted = false };
  }, []);

  const exportExcel = () => {
    
    import('xlsx').then((xlsx) => {
      // setBlocked(true);
      const workbook = xlsx.utils.book_new();
      const worksheet = xlsx.utils.json_to_sheet(resultR);
      xlsx.utils.book_append_sheet(workbook, worksheet, "Frame Loss");
      const excelBuffer = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });

      saveAsExcelFile(excelBuffer, "PS-Share-");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import('file-saver').then(async (module) => {
      if (module && module.default) {
        let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        let EXCEL_EXTENSION = '.xlsx';
        const data = new Blob([buffer], {
          type: EXCEL_TYPE
        });

        await module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
        console.log("set blocked");
        // setBlocked(false);
      }
    });
  };
  const header = (
    <div className="flex align-items-center justify-content-end gap-2">
      
      <div className="p-inputgroup"><Button type="button" icon="pi pi-file-excel" severity="success" rounded data-pr-tooltip="XLS" onClick={exportExcel} /></div>
    </div>
  );
  return (
    <div>
      <div className="card">
        <DataTable loading={blocked} sortMode="multiple" size="small" paginator rows={50} rowsPerPageOptions={[50, 100]} value={data} header={header} tableStyle={{ minWidth: '50rem' }}>
          {Object.keys(data[0]).map((col, i) => (
            // console.log(col)
            <Column key={col} sortable field={col} header={col} />
          ))}
        </DataTable>
      </div>
    </div>
  );
}






